import moment from "moment-timezone";

// State to timezone mapping - matches server-side
const STATE_TIMEZONE_MAP = {
	IL: "America/Chicago", // Illinois - Central Time
	CA: "America/Los_Angeles", // California - Pacific Time
	NY: "America/New_York", // New York - Eastern Time
	TX: "America/Chicago", // Texas - Central Time (most of it)
	FL: "America/New_York", // Florida - Eastern Time
	CO: "America/Denver", // Colorado - Mountain Time
	// Add more states as needed
};

// Get timezone from location data (client-side)
const getTimezoneFromLocationData = (locationData) => {
	if (!locationData || !locationData.state) {
		console.warn(
			`Location data missing or no state provided, defaulting to America/Chicago`
		);
		return "America/Chicago"; // Default fallback
	}

	const timezone = STATE_TIMEZONE_MAP[locationData.state.toUpperCase()];
	if (!timezone) {
		console.warn(
			`No timezone mapping for state ${locationData.state}, defaulting to America/Chicago`
		);
		return "America/Chicago"; // Default fallback
	}

	return timezone;
};

// Get timezone for location - client-side version (legacy function for backward compatibility)
const getTimezoneForLocation = (locationId) => {
	// Default to Central Time for backward compatibility
	// This should be replaced with location data usage
	console.warn(
		"Using legacy getTimezoneForLocation - consider passing location data instead"
	);
	return "America/Chicago";
};

export const generateTimeSlots = (
	duration,
	locationIdOrData,
	isToday = true
) => {
	const timeSlots = [];

	// Get timezone dynamically based on location data or locationId
	let timezone;
	if (locationIdOrData && typeof locationIdOrData === "object") {
		// It's location data with state information
		timezone = getTimezoneFromLocationData(locationIdOrData);
		console.log(
			"🕐 Using location data for timezone:",
			locationIdOrData.state,
			"→",
			timezone
		);
	} else {
		// It's a locationId - use legacy function
		timezone = getTimezoneForLocation(locationIdOrData);
		console.log(
			"🕐 Using legacy timezone for locationId:",
			locationIdOrData,
			"→",
			timezone
		);
	}

	// Get the current time in the location's timezone
	const currentTime = moment().tz(timezone);
	const startTime = currentTime.clone().set({ hour: 10, minute: 0, second: 0 }); // Set start time to 10:00 AM

	const scheduleEndTime = currentTime
		.clone()
		.set({ hour: 17, minute: 0, second: 0 }); // Set schedule end time to 5:00 PM

	// Calculate the end time based on the selected duration
	const endTime = scheduleEndTime
		.clone()
		.subtract(parseInt(duration), "minutes");

	// For today, ensure we start from the current time if it's past 10 AM, rounding up to the next 15-minute increment
	// For tomorrow, always start from 10:00 AM
	let actualStartTime;
	if (isToday) {
		actualStartTime = moment.max(startTime, currentTime);
		if (actualStartTime.minute() % 15 !== 0) {
			actualStartTime
				.add(15 - (actualStartTime.minute() % 15), "minutes")
				.seconds(0);
		}
	} else {
		// For tomorrow, always start from 10:00 AM
		actualStartTime = startTime.clone();
	}

	while (actualStartTime <= endTime) {
		const formattedTime = actualStartTime.format("h:mm a").toLowerCase();
		timeSlots.push(formattedTime);
		actualStartTime.add(15, "minutes");
	}
	return timeSlots;
};

export const timeNow = (locationIdOrData = null) => {
	let timezone;
	if (locationIdOrData && typeof locationIdOrData === "object") {
		// It's location data with state information
		timezone = getTimezoneFromLocationData(locationIdOrData);
	} else {
		// It's a locationId - use legacy function
		timezone = getTimezoneForLocation(locationIdOrData);
	}
	return moment().tz(timezone).format("h:mm a").toLowerCase();
};
